module.exports = __webpack_public_path__ + "assets/img/detail.55aea885.svg";